import React from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import { PUBLIC_ROOT, PRIVATE_ROOT } from 'portal-modules/common/constants/urls'
import checkAuthenticated from 'portal-modules/common/utils/check-authenticated'

import { connect } from 'react-redux'

export const AuthRedirect = ({ authenticated, ...rest }) => (
  <Redirect {...rest} to={authenticated ? PRIVATE_ROOT : PUBLIC_ROOT} />
)

AuthRedirect.propTypes = {
  authenticated: PropTypes.bool,
  from: PropTypes.string,
}

export default connect(state => ({ authenticated: checkAuthenticated(state) }))(
  AuthRedirect,
)
